import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'

const store = {
  state: {
    user: {
      userId: '0',
      selfAudioIntro: null
    },
    globalData: {
      login: {
        visible: false,
        type: 1 // 1注册/登录 2注册 3登录 4忘记密码 5 个人信息
      },
      visibleRegisterOrLogin: false,
      visibleRegister: false,
      visibleForget: false,
      visibleFill: false,
      visibleLogin: false
    }
  },
  mutations,
  actions: {
  },
  getter: {
  },
  modules: {
  }
}
Vue.use(Vuex)
export default new Vuex.Store({
  ...store,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js